<lum-ui-autocomplete-chip
  placeholder="Search Tag..."
  [displayProperty]="'label'"
  [options]="filteredTags"
  [selectedOptions]="selectedTags"
  [inlineChips]="inlineChips"
  [formArray]="formArray"
  [bindValue]="bindValue"
  (inputChangeEvent)="onInputChange($event)"
  (optionSelectedEvent)="onAdd($event)"
  (optionRemove)="onRemove($event)"
>
</lum-ui-autocomplete-chip>
